import type { PropsWithChildren, ReactNode } from 'react';
import styled from 'styled-components';

import { Container } from '@sorare/core/src/atoms/layout/Container';
import { Portal } from '@sorare/core/src/atoms/layout/Portal';
import { Horizontal } from '@sorare/core/src/atoms/layout/flex';
import { useIsTabletAndAbove } from '@sorare/core/src/hooks/device/useIsTabletAndAbove';

import { LineupsModeSwitcher } from '#src/components/boards/LineupsModeSwitcher/index.tsx';

const TopBar = styled(Horizontal)`
  justify-content: space-between;
  padding-block: var(--double-unit);
`;

type Props = PropsWithChildren<{
  fixture?: string;
  filters?: ReactNode;
}>;

export const LineupsLayout = ({ fixture, filters, children }: Props) => {
  const isTabletAndAbove = useIsTabletAndAbove();
  const modeSwitcher = <LineupsModeSwitcher fixture={fixture} />;

  return (
    <Container>
      <TopBar>
        {isTabletAndAbove ? modeSwitcher : <div />}
        {filters}
      </TopBar>
      {!isTabletAndAbove && (
        <Portal id="above-bottom-bar-portal">{modeSwitcher}</Portal>
      )}
      {children}
    </Container>
  );
};
